const STATINSP_UPDATEDPLANTSWITHOUTSTATINSP = (
  state,
  plantsWithoutStatInsp
) => {
  state.plantsWithoutStatInsp = plantsWithoutStatInsp;
};

const STATINSP_UPDATEDSTATINSPS = (state, statInsps) => {
  state.statInsps = statInsps;
};

const STATINSP_SETSTATINSP = (state, statInsp) => {
  state.statInsp = statInsp;
};

const STATINSP_SETSTATINSPITEM = (state, statInspItem) => {
  state.statInspItem = statInspItem;
};

const STATINSP_UPDATESTATINSPITEMS = (state, statInspItems) => {
  state.statInspItems = statInspItems;
};

const STATINSP_UPDATEPAGESSTATINSPITEMS = (state, statInspItemResults) => {
  state.statPagedInspItems = statInspItemResults;
};

const delete_item_by_id = (state, id) => {
  if (state.statInspItem.id === id) {
    state.statInspItem = {};
  }
  const i = state.statInsp.statInspItems.map(item => item.id).indexOf(id);
  if (i !== -1) state.statInsp.statInspItems.splice(i, 1);
};

export default {
  delete_item_by_id,
  STATINSP_UPDATEDPLANTSWITHOUTSTATINSP,
  STATINSP_UPDATEDSTATINSPS,
  STATINSP_SETSTATINSP,
  STATINSP_SETSTATINSPITEM,
  STATINSP_UPDATESTATINSPITEMS,
  STATINSP_UPDATEPAGESSTATINSPITEMS
};
